<script setup lang="ts">
    import { computed } from 'vue'

    /* ---------------- props / emits ---------------- */

    const props = defineProps<{
        propOpened: boolean
        propSurveyStarted: boolean
    }>()

    const emit = defineEmits<{
        (e: 'stop-meeting'): void
        (e: 'start-survey'): void
        (e: 'stop-survey'): void
        (e: 'close-dialog'): void
    }>()

    /* ---------------- derived ---------------- */

    const opened = computed(() => props.propOpened)
    const surveyStarted = computed(() => props.propSurveyStarted)

    /* ---------------- actions ---------------- */

    function stopMeeting()
    {
        emit('stop-meeting')
    }

    function startSurvey()
    {
        emit('start-survey')
    }

    function stopSurvey()
    {
        emit('stop-survey')
    }

    function close()
    {
        emit('close-dialog')
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Stopping the meeting​</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p class="lead">
                            You're about to end the meeting. Let's just tidy up a little...
                        </p><br />

                        <table class="table">
                            <tbody>
                                <tr v-if="surveyStarted === true">
                                    <td>
                                        <h5>Survey is open</h5>
                                        <p>The survey is still open. This means that people can still change their votes.​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="stopSurvey">Close survey</button>
                                    </td>
                                </tr>
                                <tr v-if="surveyStarted === false">
                                    <td>
                                        <h5>Survey is closed</h5>
                                        <p>The survey is closed. This means that people cannot change their votes.​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="startSurvey">Open survey</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="modal-footer">
                        <button @click="stopMeeting" type="button" class="btn btn-primary">Stop the meeting</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>